import ls from '@livesession/sdk';
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import dayjs from 'dayjs';
import { Footer, NavbarFull } from '.';
import { useCurrentUser, useExtension } from '../hooks';
import { analyticsConsentAtom } from '../store';

export const Layout = () => {
  const { user } = useCurrentUser();
  const analyticsConsent = useAtom(analyticsConsentAtom)[0];
  const { pingExtension } = useExtension();

  useEffect(() => {
    pingExtension();
    // We only want to check for extension existence once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // LiveSession is initialized in cookieConsentServices when user accepts analytics.
  // Here we only identify and send page views when the service is enabled.
  useEffect(() => {
    if (!analyticsConsent.liveSession) return;

    if (user) {
      try {
        ls.identify({
          email: user.email || '',
          name: user.name || '',
          params: {
            userCartsLength: user.carts.length || '',
            loginCount: user.loginCount || '',
            userCreated: user.createTimestamp
              ? dayjs(user.createTimestamp).format('MMM DD, YYYY - HH:mm')
              : '',
            userLoggedIn: user.loginTimestamp
              ? dayjs(user.loginTimestamp).format('MMM DD, YYYY - HH:mm')
              : '',
            previouslyLoggedIn: user.previousLoginTimestamp
              ? dayjs(user.previousLoginTimestamp).format(
                  'MMM DD, YYYY - HH:mm',
                )
              : '',
            provider: user.provider || '',
            plan: user.subscription.tier || '',
          },
        });
      } catch (e) {
        console.error('LS error:', e);
      }
    }

    ls.newPageView();
  }, [user, analyticsConsent.liveSession]);

  return (
    <>
      <div className='flex-[1_0_auto] bg-white'>
        <NavbarFull />
        <Outlet />
      </div>
      <Footer />
    </>
  );
};
